import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

// Handles the Google OAuth redirect: reads session_id from the URL fragment,
// exchanges it on the backend, then routes the user into the app.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { googleSession } = useApp();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = location.hash || "";
        const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
        (async () => {
            if (!sid) { navigate("/login", { replace: true }); return; }
            try {
                await googleSession(sid);
                window.history.replaceState(null, "", window.location.pathname);
                // Route to dashboard if the user already has a business, else onboarding.
                let dest = "/onboarding";
                try { if ((await api.get("/my/business")).data) dest = "/dashboard"; } catch {}
                navigate(dest, { replace: true });
            } catch {
                navigate("/login", { replace: true });
            }
        })();
    }, [location.hash, googleSession, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
            <Loader2 className="w-6 h-6 animate-spin text-accent" />
        </div>
    );
}
